import client from "./clients/portalClient";

const getAllServiceMatrixData = () => client.get(`/service_matrix`);

const serviceMatrixApi = {
  getAllServiceMatrixData,
};

export default serviceMatrixApi;
